import React, { useEffect, useState } from "react";
import ApexCharts from "apexcharts";
import jsonData from "../../../../current-survey-numeric.json";
import { FILTER_CONFIG } from "../../../../config/filterconfig"; // Import centralized filter config

const D01BarChartViz09 = ({ filterCriteria }) => {
  const [categories, setCategories] = useState([]);
  const [data, setData] = useState([]);

  useEffect(() => {
    // Helper function to map filter keys to JSON keys
    const getJsonKey = (filterKey) => {
      const config = FILTER_CONFIG.find((item) => item.fieldName === filterKey);
      return config ? config.jsonKey : filterKey; // Default to the key if no mapping is found
    };

    // Apply filtering logic based on `filterCriteria`
    const filterData = (item) => {
      return Object.keys(filterCriteria).every((key) => {
        const jsonKey = getJsonKey(key); // Map filter key to JSON field
        if (filterCriteria[key].length === 0) {
          return true; // If no filter is selected, include all items
        }
        return filterCriteria[key].includes(item[jsonKey]);
      });
    };

    // Filter data using the filter criteria
    const filteredData = jsonData.filter(filterData);

    // Aggregate data by demcat09 (demographic_category_08 in the new JSON)
    const demcat09Counts = filteredData.reduce((acc, item) => {
      const demcat09 = item.demographic_category_09; // Use demographic_category_08 for Ethnicity
      if (!acc[demcat09]) {
        acc[demcat09] = 0;
      }
      acc[demcat09]++;
      return acc;
    }, {});

    // Sort Demographic Category 09 names alphabetically
    const demcat09Names = Object.keys(demcat09Counts).sort((a, b) =>
      a.localeCompare(b)
    );
    const chartData = demcat09Names.map((demcat09) => demcat09Counts[demcat09]);

    // Update state
    setCategories(demcat09Names);
    setData(chartData);

    // Chart height calculation
    const barHeight = 25; // Set bar height in pixels
    const minBars = 10; // Minimum number of bars to display
    const chartHeight = Math.max(
      barHeight * demcat09Names.length,
      barHeight * minBars
    ); // Total chart height

    // Chart options
    const optionsViz09 = {
      series: [
        {
          name: "Count",
          data: chartData,
        },
      ],
      colors: ["#004983"],
      chart: {
        type: "bar",
        height: chartHeight, // Dynamic height based on number of bars
        width: "95%",
      },
      legend: {
        show: false,
      },
      plotOptions: {
        bar: {
          borderRadius: 4,
          borderRadiusApplication: "end",
          horizontal: true,
          distributed: false,
          dataLabels: {
            position: "top",
          },
        },
      },
      dataLabels: {
        enabled: true,
        offsetX: 28, // Move labels off the bars
        style: {
          colors: ["#000"], // Set data labels to black
        },
        dropShadow: {
          enabled: true,
          top: 0,
          left: 0,
          blur: 2.5,
          color: "#fff",
          opacity: 1,
        },
      },
      xaxis: {
        categories: demcat09Names,
      },
    };

    // Render the chart
    const viz09 = new ApexCharts(
      document.querySelector("#viz-09"),
      optionsViz09
    );
    viz09.render();

    // Cleanup chart on component unmount
    return () => {
      viz09.destroy();
    };
  }, [filterCriteria]);

  return (
    <div style={{ width: "100%", overflowY: "auto" }}>
      <div id="viz-09"></div>
    </div>
  );
};

export default D01BarChartViz09;
